import React from "react";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";

const DetailOfComparisonItem = ({
  detailOfSelectedItem,
  versionsOfSelectedItem,
  selectedVersion,
  validFromDate,
  validToDate,
  onVersionSelect,
  onDateChange,
}) => {
  if (!detailOfSelectedItem) return null;

  const DatePickerButton = ({ value, onClick }) => (
    <Button onClick={onClick}>
      <span className="glyphicon glyphicon-calendar" /> {value}
    </Button>
  );

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <h5>Versions:</h5>
        {versionsOfSelectedItem && (
          <div>
            <div>
              {versionsOfSelectedItem.map((version) => (
                <Button
                  key={version}
                  onClick={() => onVersionSelect(version)}
                  className="m-1"
                  style={{
                    backgroundColor:
                      selectedVersion === version ? "#003299" : "transparent",
                    color: selectedVersion === version ? "white" : "black",
                  }}
                >
                  {version}
                </Button>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div className="mr-5">
            <b>Valid from </b>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={validFromDate}
              onChange={(date) => onDateChange("validFromDate", date)}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              customInput={<DatePickerButton />}
            />
          </div>
          <div className="mr-5">
            <b>Valid to </b>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={validToDate}
              onChange={(date) => onDateChange("validToDate", date)}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              customInput={<DatePickerButton />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailOfComparisonItem;
